import type {Repository} from '@github-ui/current-repository'
import type {PageError} from '@github-ui/react-core/app-routing-types'
import type {CurrentUser, RefInfo} from '@github-ui/repos-types'
import type {ReposFileTreeData, TreePayload} from './tree-types'

export function isErrorPayload(payload: unknown): payload is DataRouterErrorPayload {
  return isRoutePayloadMap(payload) && 'error' in payload
}

function isRoutePayloadMap(data: unknown): data is Record<string, unknown> {
  return typeof data === 'object' && data !== null && !Array.isArray(data)
}

export function getErrorPayload(data: unknown, routeId: string): DataRouterErrorPayload | undefined {
  if (!isRoutePayloadMap(data)) return undefined

  const payload = data[routeId]

  return isErrorPayload(payload) ? payload : undefined
}

export interface DataRouterErrorPayload {
  path: string
  repo: Repository
  refInfo: RefInfo
  currentUser: CurrentUser
  fileTree: ReposFileTreeData
  fileTreeProcessingTime: number
  foldersToFetch: string[]
  allShortcutsEnabled: boolean
  tree: TreePayload
  error: PageError
  copilotAccessAllowed?: boolean
  copilotSpacesEnabled?: boolean
}
